import React, { useContext, useState, useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import { AuthContext } from "../../contexts/Auth";
import { useFetch } from "../../hooks/fetch";
import CustomerContext from "../../contexts/Customer";
import Breadcrumb from "../../components/Breadcrumb";
import SingleColumnPage from "../../components/SingleColumnPage";
import UserCustomerUsers from "../UserCustomerUsers";
import NewUser from "../UserNewCustomerUser";
import UserUserInfo from "../UserUserInfo";

export default function CustomerUsersIndex() {
  const { state } = useContext(AuthContext);
  const [data] = useFetch(`/customers/${state.user.customer_id}`);
  const [customer, setCustomer] = useState(null);

  useEffect(() => {
    var isApiSubscribed = true;
    if (isApiSubscribed) {
      setCustomer(data);
    }
    return () => {
      isApiSubscribed = false;
    };
  }, [data]);

  const breadcrumbs = () => (
    <>
      <Breadcrumb title="Users" to="/customer/users" />
    </>
  );

  return (
    <SingleColumnPage breadcrumbs={breadcrumbs}>
      <CustomerContext.Provider value={{ customer, setCustomer }}>
        <Switch>
          <Route path="/customer/users/new" component={NewUser} exact />
          <Route path="/customer/users/:id" component={UserUserInfo} exact />
          <Route path="/customer/users" component={UserCustomerUsers} />
        </Switch>
      </CustomerContext.Provider>
    </SingleColumnPage>
  );
}
